import React, { useState } from 'react';
import { Button, Badge, Typography } from 'antd';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';

const { Text } = Typography;

const DIAS_SEMANA = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'];
const MESES = ['Janeiro','Fevereiro','Março','Abril','Maio','Junho','Julho','Agosto','Setembro','Outubro','Novembro','Dezembro'];

export default function CalendarioSimples({ eventos = [], onDiaClick, onEventoClick }) {
  const [mesAtual, setMesAtual] = useState(dayjs().startOf('month'));

  const diasNoMes = mesAtual.daysInMonth();
  const primeiroDia = mesAtual.day(); // 0=dom
  const totalCells = Math.ceil((diasNoMes + primeiroDia) / 7) * 7;

  const getEventosDia = (dia) => {
    const dataStr = mesAtual.date(dia).format('YYYY-MM-DD');
    return eventos.filter(e => e.start?.substring(0, 10) === dataStr);
  };

  const hoje = dayjs().format('YYYY-MM-DD');

  return (
    <div>
      {/* Header */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 16, marginBottom: 12 }}>
        <Button icon={<LeftOutlined />} size="small" onClick={() => setMesAtual(mesAtual.subtract(1, 'month'))} />
        <Text strong style={{ fontSize: 16, minWidth: 180, textAlign: 'center' }}>
          {MESES[mesAtual.month()]} {mesAtual.year()}
        </Text>
        <Button icon={<RightOutlined />} size="small" onClick={() => setMesAtual(mesAtual.add(1, 'month'))} />
        <Button size="small" onClick={() => setMesAtual(dayjs().startOf('month'))}>Hoje</Button>
      </div>

      {/* Dias da semana */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: 2, marginBottom: 4 }}>
        {DIAS_SEMANA.map(d => (
          <div key={d} style={{ textAlign: 'center', fontSize: 12, fontWeight: 'bold', color: '#888', padding: '4px 0' }}>{d}</div>
        ))}
      </div>

      {/* Grid de dias */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: 2 }}>
        {Array.from({ length: totalCells }).map((_, idx) => {
          const dia = idx - primeiroDia + 1;
          const valido = dia >= 1 && dia <= diasNoMes;
          const dataStr = valido ? mesAtual.date(dia).format('YYYY-MM-DD') : '';
          const evsDia = valido ? getEventosDia(dia) : [];
          const isHoje = dataStr === hoje;

          return (
            <div
              key={idx}
              onClick={() => valido && onDiaClick && onDiaClick({ dateStr: dataStr })}
              style={{
                minHeight: 70, padding: 4, border: '1px solid #f0f0f0', borderRadius: 4,
                background: isHoje ? '#e6f7ff' : valido ? 'white' : '#fafafa',
                cursor: valido ? 'pointer' : 'default',
                overflow: 'hidden',
              }}
            >
              {valido && (
                <>
                  <div style={{
                    fontWeight: isHoje ? 'bold' : 'normal',
                    color: isHoje ? '#1890ff' : '#333',
                    fontSize: 13, marginBottom: 2
                  }}>{dia}</div>
                  {evsDia.slice(0, 3).map((ev, i) => (
                    <div key={i} onClick={e => { e.stopPropagation(); onEventoClick && onEventoClick({ event: { extendedProps: ev.extendedProps } }); }}
                      style={{ background: ev.color || '#1890ff', color: 'white', fontSize: 10, borderRadius: 3, padding: '1px 4px', marginBottom: 1, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', cursor: 'pointer' }}>
                      {ev.title}
                    </div>
                  ))}
                  {evsDia.length > 3 && <div style={{ fontSize: 10, color: '#888' }}>+{evsDia.length - 3} mais</div>}
                </>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
